module.exports = __webpack_public_path__ + "img/ihs-logo-bw.5aa9eae4.svg";